import React from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';

import YardiRenewalStepper from './YardiRenewalStepper';
import LeaseHolderCard from './LeaseHolderCard';
import { getLease } from 'actions/landlordApplicationsActions';

const StyledContainer = styled.div`
  padding: 0 15px 15px 15px;
`;

const StyledCotenantCards = styled.div`
  margin-bottom: 48px;
`;

const StyledButtonContainer = styled.div`
  text-align: center;
  margin-bottom: 72px;
`;

const RenewalStatusDetails = ({
  cotenants,
  toggleDrawer,
  leaseId,
  getLease,
  toggleInPersonDocumentSigning,
}) => {
  const viewApplicants = () => {
    getLease(leaseId).then(() => {
      browserHistory.push('/companies/review_applicants');
    });
  };

  return (
    <StyledContainer>
      <h3>{getTranslatedString('landlordPortal.rentRoll.renewals.renewalOverview')}</h3>
      <YardiRenewalStepper
        toggleDrawer={toggleDrawer}
        setInPersonDocumentSigning={toggleInPersonDocumentSigning}
      />
      <h3>{getTranslatedString('landlordPortal.rentRoll.renewals.leaseHolder')}</h3>
      <StyledCotenantCards>
        {cotenants
          .sort((a, b) => a.id - b.id)
          .map(cotenant => <LeaseHolderCard cotenant={cotenant} />)}
      </StyledCotenantCards>
      <StyledButtonContainer>
        <FlatButton
          label={getTranslatedString('landlordPortal.rentRoll.renewals.viewAllApplicantDetails')}
          primary
          backgroundColor={colors.LIGHTEST_GRAY}
          hoverColor={colors.GRAY}
          style={{
            color: AccentColor(),
          }}
          onClick={viewApplicants}
        />
      </StyledButtonContainer>
    </StyledContainer>
  );
};

const mapStateToProps = store => ({
  leaseId: store.leaseDetails.leaseDetails.id,
});

const mapDispatchToProps = {
  getLease,
};

export default connect(mapStateToProps, mapDispatchToProps)(RenewalStatusDetails);
